// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__X9TUK","title":"Header_title__3KmLh","side":"Header_side__21hNv"};